import ComparisonResultRow from '../../../entities/ComparisonResultRow'

const filterRowsByOnlyDifferent = (
    rows: ComparisonResultRow[],
    onlyDifferent: boolean,
): ComparisonResultRow[] => {
    if (!onlyDifferent) {
        return rows
    }
    return rows.filter(row => row.comparability === 'DIFFERENT')
}

export default filterRowsByOnlyDifferent
